import { Flex, Skeleton, Typography } from 'antd';
import themeToken from '@lib/theme/tokens/index';

const { Title, Text } = Typography;

type Props = {
  title: string;
  value?: string | number | React.ReactNode;
  gap?: number;
  titleFontSize?: number;
  titleFontWeight?: number;
  valueFontSize?: number;
  align?: 'stretch' | 'center' | 'start' | 'end';
  vertical?: boolean;
};

const CommonDetailInfo = ({
  title,
  value,
  gap = 6,
  titleFontSize = themeToken.fontSize,
  titleFontWeight = themeToken.fontWeightStrong,
  valueFontSize = themeToken.fontSizeLG,
  align = 'center',
  vertical,
}: Props) => {
  return (
    <Flex gap={gap} align={align} vertical={vertical}>
      <Title
        level={2}
        style={{
          color: themeToken['branding-natural-6'],
          fontSize: titleFontSize,
          fontWeight: titleFontWeight,
        }}
      >
        {title}
      </Title>
      {value || value === 0 ? (
        <Text
          style={{
            color: themeToken.colorPrimary,
            fontSize: valueFontSize,
            fontWeight: themeToken.fontWeightStrong,
          }}
        >
          {value}
        </Text>
      ) : (
        <Skeleton.Button size="small" active={true} />
      )}
    </Flex>
  );
};

export default CommonDetailInfo;
